import type React from 'react';

import { useEventListQuery } from '@vlabs/monokit/entities/events/api';
import type { EventListPermissions } from '@vlabs/monokit/entities/events/event-list-table';
import { EventListTableView } from '@vlabs/monokit/entities/events/event-list-table';
import { EventListTableViewer } from '@vlabs/monokit/widgets';

interface EventListViewerProps {
  permissions: EventListPermissions;
}

function EventListViewer({ permissions }: EventListViewerProps): React.JSX.Element {
  return (
    <EventListTableViewer
      permissions={permissions}
      tableView={EventListTableView}
      useGetEventsHook={useEventListQuery}
    />
  );
}

export { EventListViewer };
